<template>
    <div class="advanced-collate-main">
        <!-- 1. 表单部分 -->
        <div class="advanced-collate-form width90p">
            <!-- 输入姓名+分组 -->
            <div class="collate-form-box">
                <label class="collate-form-label cf-label-two">姓 名</label>
                <input class="collate-form-input" type="text" maxlength="15" placeholder="输入称呼" v-model="formData.f_name" >
                <div class="collate-form-choose cf-pos-right" @click="clickChooseGroup">
                    <span v-if="choosedGroup.id > 0" class="cf-icon-text">{{choosedGroup.f_name.slice(0, 6)}}</span>
                    <span v-else class="cf-icon-text">选择分组</span>
                    <i class="cf-icon-right iconfont icon-xiangyou"></i>
                </div>
            </div>
            <!-- 选择性别 -->
            <div class="collate-form-box bdb-none">
                <label class="collate-form-label cf-label-two">性 别</label>
                <span class="collate-form-sex" @click="selectSex(0)">
                    <i class="iconbg icon-sex icon-male"></i>
                    <i class="cf-icon-sex iconfont" :class="{'icon-selected' : formData.sex == 0, 'icon-unselected' : formData.sex == 1}"></i>
                </span>
                <span class="collate-form-sex" @click="selectSex(1)">
                    <i class="iconbg icon-sex icon-female"></i>
                    <i class="cf-icon-sex iconfont" :class="{'icon-selected' : formData.sex == 1, 'icon-unselected' : formData.sex == 0}"></i>
                </span>
                <div class="collate-form-choose cf-pos-right" @click="chooseLabel">
                    <span v-if="selectedLabelString != ''" class="cf-icon-text">{{selectedLabelString.slice(0, 5)}}</span>
                    <span v-else class="cf-icon-text">标签备注</span>
                    <i class="cf-icon-right iconfont icon-xiangyou"></i>
                </div>
            </div>
        </div>
        <!-- 2. 四柱部分:初始化当前时间的八字 -->
        <div class="advanced-collate-content">
            <div class="layout-asb-title dsp-flex">
                <div class="layout-asb-item"><span>年柱</span></div>
                <div class="layout-asb-item"><span>月柱</span></div>
                <div class="layout-asb-item"><span>日柱</span></div>
                <div class="layout-asb-item"><span>时柱</span></div>
            </div>
            <div class="layout-asb-list dsp-flex">
                <div class="layout-asb-item" v-for="arr in siZhuEightWordArr" :key="'asb-item' + arr[0].text + siZhuEightWordArr.indexOf(arr)">
                    <div class="layout-asb-box" v-for="data in arr" @click="clickAdvancedCollateItem(data, [siZhuEightWordArr.indexOf(arr), arr.indexOf(data)])" :key="'asb-box' + data.text + siZhuEightWordArr.indexOf(arr) + arr.indexOf(data)">
                        <span class="layout-asb-word" v-bind:class="'wd-' + data.propXingEn">{{data.text}}</span>
                    </div>
                </div>
            </div>
        </div>
        <!-- 3. 数据列表:初始化与当前八字相同的列表 -->
        <div class="advanced-collate-list">
            <div class="advanced-collate-item">
                <p class="p-first">{{yearStr}}</p>
                <p class="p-second">为你查到下列日期作为起盘时间</p>
            </div>
            <div class="advanced-collate-item" v-for="data in sameEightWordList" :key="'same-item' + data.birthday" v-bind:class="{'cur-item' : data.selected, 'cur-item-chaodai' : data.chaodai != ''}" @click="clickSameItem(data)">
                <p class="p-first"><span class="span-sular-date">{{data.text_one}}</span> <span class="span-chaodai" v-show="data.chaodai != ''">{{'['+data.chaodai.c+']'}}{{data.chaodai.h}} {{data.chaodai.n}}{{data.chaodai.cha+'年'}}</span></p>
                <p class="p-second">{{data.text_two}}</p>
                <i class="iconfont icon-selected ci-icon"></i>
            </div>
        </div>

        <!-- 4. 选择框 -->
        <choose-item-pop :showPop='showChooseItemPop' :itemList='collateChooseItemList' :cancelFunc='clickChooseItemPopOverLay' :itemFunc='clickChooseItem'></choose-item-pop>
    </div>
</template>

<script>
import * as consts from '../../modules/data/base/consts'
import { DOM } from '../../modules/dom';
import ChooseItemPop from "../../components/ChooseItemPop.vue";
import { CONFIG } from '../../modules/config';
export default {
    name: 'AdvancedCollateForm',
    components: { ChooseItemPop }, 
    props: {
        itemSize: {
            type: Object,
            default() {
                return {width: 0, height: 0}
            }
        },
        basicPos: {
            type: Object,
            default() {
                return {x: 0, y: 0}
            }
        },
        chooseGroupFunc: {
            type: Function,
            default: function() {}
        },
        chooseLabelFunc: {
            type: Function,
            default: function() {}
        }
    },
    computed: {
        choosedGroup() {
            return this.$store.state.group.choosedGroup;
        },
        selectedLabelString() {
            return this.$store.state.label.selectedLabelString;
        },
        formData() {
            return this.$store.state.collate.formData;
        },
        siZhuEightWordArr() {
            return this.$store.state.collate.advanced.siZhuEightWordArr;
        },
        showChooseItemPop() {
            return this.$store.state.collate.advanced.showChooseItemPop;
        },
        collateChooseItemList() {
            return this.$store.state.collate.advanced.collateChooseItemList;
        },
        sameEightWordList() {
            return this.$store.state.collate.advanced.sameEightWordList;
        }
    },
    data() {
        return {
            yearStr: '可查范围：公元' + consts.CONST_START_END_YEAR[0] + '-' + consts.CONST_START_END_YEAR[1] + '年',
        }  
    },
    mounted() {
        var me = this;
        setTimeout(() => {
            me.initDom();
        }, 20);
    },
    methods: {
        initDom() {
            var topDom = document.getElementsByClassName('collate-top')[0],
                // titleDom = document.getElementsByClassName('title-bar')[0],
                formDom = document.getElementsByClassName('advanced-collate-form')[0],
                contentDom = document.getElementsByClassName('advanced-collate-content')[0],
                listDom = document.getElementsByClassName('advanced-collate-list')[0];
            if(topDom) {
                listDom.style.height = (innerHeight-topDom.clientHeight-formDom.clientHeight-contentDom.clientHeight) + 'px';
            }
            if(CONFIG.platform == 'web' && listDom) {
                listDom.style.height = (innerHeight-formDom.clientHeight-contentDom.clientHeight-52) + 'px';
            }
        },
        clickChooseGroup() {
            if(this.chooseGroupFunc && typeof(this.chooseGroupFunc) == 'function') {
                this.chooseGroupFunc();
            }
        },
        selectSex(index) {
            this.$store.state.collate.formData.sex = index;
        },
        chooseLabel() {
            if(this.chooseLabelFunc && typeof(this.chooseLabelFunc) == 'function') {
                this.chooseLabelFunc();
            }
        },
        clickAdvancedCollateItem(data, pos) {
            this.$store.dispatch('collate/updateCollateChooseData', {
                data: data, pos: pos
            })
            this.$store.state.collate.advanced.showChooseItemPop = true;
            this.$store.state.collate.advanced.collateClickBoxPos = pos;
            var me = this;
            setTimeout(() => {
                DOM.updateChooseItemPopPos(pos, this.basicPos, this.itemSize);
            }, 0);
        },
        clickChooseItemPopOverLay() {
            this.$store.state.collate.advanced.showChooseItemPop = false;
        },
        clickChooseItem(data) {
            this.$store.state.collate.advanced.showChooseItemPop = false;
            this.$store.dispatch('collate/chooseCollateChooseData', {
                data: data, basicPos: this.basicPos, itemSize: this.itemSize
            });
        },
        clickSameItem(data) {
            console.log('clickSameItem-----', data.birthday)
            // 消除所有选项
            for(var itemData of this.$store.state.collate.advanced.sameEightWordList) {
                itemData.selected = itemData.birthday == data.birthday ? true : false;
                this.$store.state.collate.formData.birthday = data.birthday;
            }
        }
    }
}
</script>